import getPlanAsURL from 'core/controllerPlans/getPlanAsURL'
import isArray from 'utils/validation/isArray'
import { ALL_DENTAL, DENTAL } from 'core/constants/products'
import store from 'utils/store/withMiddleware'

const NEXT_STEP_PATHS = /\/details\/|\/eligibility\//

/** Triggered when the user clicks the Continue to Checkout button */
function addPlanId(e) {
  const anchor = e.data ? e.data.anchor : ''
  const state = store.getState()
  const stateAcronym = state.hcStorage.location.state_acronym

  const isNextStepLink = this.href && NEXT_STEP_PATHS.test(this.href)
  const dentalPlanIds = ALL_DENTAL.flatMap(productId => state.plansByType[productId])
  const hasDental = state.addOns.some(addOn => dentalPlanIds.includes(addOn))

  if (
    stateAcronym !== 'PA' &&
    isNextStepLink &&
    state.showMissedModal &&
    !hasDental &&
    e.currentTarget.id.includes('eligibility-link')
  ) {
    e.preventDefault()
    $('#missed-dnv').modal('show')
    store.update({ showMissedModal: false }, true)
  } else {
    this.href += getPlanAsURL(state) + anchor
  }
}

export default addPlanId
